// extracted by mini-css-extract-plugin
export var profileMain = "profile-main_H26kCsahj_L0rgBvAscA";
export var profileMainContent = "profile-main__content_jb4tt8KXnQCs6gfp0zvb";
export var profileMainHeader = "profile-main__header_FC3FspgGaHgPcRNPCsN6";